module.exports = __webpack_public_path__ + "static/videos/etch_007.f823376.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_007.mp4
// module id = 469
// module chunks = 1